var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center origin-top-left !pointer-events-none",class:_vm.$style.container},[_c(_vm.widgetComponent,{tag:"component",staticClass:"!pointer-events-none",attrs:{"widget":_vm.formattedWidget,"target-step-index":_vm.targetStepIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }